@if (form) {
  <form [formGroup]="form">
    <p-panel class="mb-4" header="Enter new Provider information">
      <div formGroupName="serviceProviderNote" class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
        <div class="col-span-12 md:col-span-6">
          <div class="field">
            <label class="field-required">NPI:</label>
            <div class="p-field-value">
              <p-input-mask
                slotChar=""
                mask="999999999999"
                [maxlength]="12"
                formControlName="npi"
                [autoClear]="false"
                data-test-id="npi-value"
              ></p-input-mask>
            </div>
          </div>
            <div class="field">
            <label class="field-required">Home Health Agency Name:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="providerName" />
            </div>
          </div>
        </div>
        <div formGroupName="address" class="col-span-12 md:col-span-6">
          <div class="field">
            <label>Address 1:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="addressLine1" />
            </div>
          </div>
          <div class="field">
            <label>Address 2:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="addressLine2" />
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="city" />
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="state"/>
            </div>
          </div>
          <div class="field">
            <label>ZIP Code:</label>
            <div class="p-field-value">
              <input pInputText type="text" formControlName="zipCode" />
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>
}
